import {gql} from "@apollo/client";

export const TFA_ON_MUTATION = gql(`
    mutation OnTFA($code: String!) {
      onTFA(tfaCode: $code)
    }
`);
